import React, { useState, useRef } from "react";
import Breadcrumbs from "../breadcrumbs/Breadcrumbs";
import Thumbnail1 from "../../assets/images/Products/productD-1.jpg";
import Thumbnail2 from "../../assets/images/Products/productD-2.jpg";
import Thumbnail3 from "../../assets/images/Products/productD-3.jpg";
import Thumbnail4 from "../../assets/images/Products/productD-4.jpg";
import Thumbnail5 from "../../assets/images/Products/productD-5.jpg";
import { FaStar } from "react-icons/fa";
import { FaPencilAlt } from 'react-icons/fa';
import { FiPlus } from 'react-icons/fi';
import { RiShoppingCartLine } from "react-icons/ri";
import { LuBadgeCheck } from "react-icons/lu";
import { FiHeart, FiShoppingCart, FiEye, FiTrash2 } from "react-icons/fi";
import { FaHeart } from "react-icons/fa";
import { toast } from "react-hot-toast";
import { Link, useNavigate, useParams } from "react-router-dom";
import { MdFavoriteBorder, MdFavorite, MdOutlineShare } from "react-icons/md";
import { PiClockCountdown, PiArrowClockwiseFill } from "react-icons/pi";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/zoom";
import "react-photo-view/dist/react-photo-view.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Thumbs } from "swiper/modules";
import { PhotoProvider, PhotoView } from "react-photo-view";
import Manufatur1 from "../../assets/images/Products/manifature-1.jpg";
import Manufatur2 from "../../assets/images/Products/manifature-2.jpg";
import Manufatur3 from "../../assets/images/Products/manifature-3.jpg";
import Manufatur4 from "../../assets/images/Products/manifature-4.jpg";
import Manufatur5 from "../../assets/images/Products/manifature-5.jpg";
import Customer1 from '../../assets/images/Review/customer-1.jpg';
import Product1 from "../../assets/images/Products/product-1.jpg";
import Product2 from "../../assets/images/Products/product-1.1.jpg";
import Product3 from "../../assets/images/Products/product-2.jpg";
import Product4 from "../../assets/images/Products/product-2.2.jpg";
import Product5 from "../../assets/images/Products/product-3.jpg";
import Product6 from "../../assets/images/Products/product-3.3.jpg";
import Product7 from "../../assets/images/Products/product-4.jpg";
import Product8 from "../../assets/images/Products/product-4.4.jpg";

import { Helmet } from 'react-helmet-async';
import apiClient from "../../services/apiClient";
import { IMAGE_PATH } from "../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { addToCart as addToCartAction, removeFromCart } from "../../features/cart/cartSlice";
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';

const ProductDetails = () => {
const { id } = useParams();
const [product, setProduct] = useState(null);
const [quantity, setQuantity] = useState(1);
const [isFavorite, setIsFavorite] = useState(false);
const [selectedSize, setSelectedSize] = useState("4 mm");
const [thumbsSwiper, setThumbsSwiper] = useState(null);
const [mainSwiper, setMainSwiper] = useState(null);
const [activeIndex, setActiveIndex] = useState(0);
const [hoveredProduct, setHoveredProduct] = useState(null);
const [imageHovered, setImageHovered] = useState(null);
const [showReviewForm, setShowReviewForm] = useState(false);
const [reviewTitle, setReviewTitle] = useState("");
const [reviewDescription, setReviewDescription] = useState("");
const [reviewRating, setReviewRating] = useState(0);
const [reviewerName, setReviewerName] = useState("");
const [reviewerEmail, setReviewerEmail] = useState("");
const [reviewImages, setReviewImages] = useState([]);
const [errors, setErrors] = useState({});
const [isSubmitting, setIsSubmitting] = useState(false);
const [productSizes, setProductSizes] = useState([]);
const navigate = useNavigate();
const [selectedColor, setSelectedColor] = useState("Black / Black");
const [colorVariants, setColorVariants] = useState([
  
]);

const dispatch = useDispatch();
const user = useSelector((state) => state.auth.user);
const cart = useSelector((state) => state.cart.items);
const queryClient = useQueryClient();

// React Query for product details
const { data: productData, isLoading: productLoading, error: productError } = useQuery({
  queryKey: ['product', id, user?.id],
  queryFn: async () => {
    const response = await apiClient.get(`/products/${id}`, {
      params: {
        user_id: user ? user.id : null,
      }
    });
    return response.data;
  },
  enabled: !!id,
  staleTime: 5 * 60 * 1000, // 5 minutes
  cacheTime: 10 * 60 * 1000, // 10 minutes
});

// React Query for recommended products
const { data: recommendedProducts = [], isLoading: recommendedLoading } = useQuery({
  queryKey: ['recommended-products', user?.id],
  queryFn: async () => {
    const response = await apiClient.get('/products-list', {
      params: {
        user_id: user ? user.id : null,
      }
    });
    return response.data.data.filter(p => p.is_combo !== true).slice(0, 4);
  },
  staleTime: 5 * 60 * 1000,
  cacheTime: 10 * 60 * 1000,
});

// React Query for product sizes and variants
const { data: sizesData } = useQuery({
  queryKey: ['product-sizes', id, selectedSize],
  queryFn: async () => {
    const response = await apiClient.get(`/sizes/${id}`, {
      params: {
        size: selectedSize,
      }
    });
    console.log(response)
    return response.data;
  },
  enabled: !!id,
});

// Mutation for wishlist toggle
const wishlistMutation = useMutation({
  mutationFn: async ({ productId, productType }) => {
    const payload = {
      product_id: productId,
      user_id: user.id,
      product_type: productType,
    };
    return await apiClient.post("/wishlist", payload);
  },
  onSuccess: (response, variables) => {
    const isFavNow = response.data.fav_status === 1;
    setIsFavorite(isFavNow);
    toast.success(isFavNow ? "Added to wishlist" : "Removed from wishlist");

    // Update recommended products cache
    queryClient.setQueryData(['recommended-products', user?.id], (oldData) => {
      if (!oldData) return [];
      return oldData.map(p =>
        p.id === variables.productId ? { ...p, is_fav: isFavNow } : p
      );
    });
  },
  onError: (error) => {
    console.error("Wishlist error", error);
    toast.error("Failed to update wishlist.");
  }
});

// Mutation for review submission
const reviewMutation = useMutation({
  mutationFn: async (formData) => {
    return await apiClient.post('/reviews', formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  },
  onSuccess: (response) => {
    toast.success('Review submitted successfully!');
    
    // Reset form
    setReviewRating(0);
    setReviewTitle('');
    setReviewDescription('');
    setReviewImages([]);
    setReviewerName('');
    setReviewerEmail('');
    setShowReviewForm(false);
    
    // Invalidate product query to refetch with new review
    queryClient.invalidateQueries({ queryKey: ['product', id] });
  },
  onError: (error) => {
    console.error('Error submitting review:', error);
    toast.error('Failed to submit review. Please try again.');
  }
});

// Update local state when query data loads
React.useEffect(() => {
  if (productData) {
    setProduct(productData.product);
    setIsFavorite(productData .is_fav);
    setSelectedSize(productData.product.size);
    setSelectedColor(productData.product.varient || null);
  }
}, [productData]);

// Update sizes and variants when sizes data loads
React.useEffect(() => {
  
  if (sizesData) {
    setProductSizes(sizesData.sizes || []);
    setColorVariants(sizesData.varients || []);
  }
}, [sizesData]);

// Set user info for reviews
React.useEffect(() => {
  if (user) {
    setReviewerEmail(user?.email);
    setReviewerName(user?.name);
  }
}, [user]);

// Show error toast if product fetch fails
React.useEffect(() => {
  if (productError) {
    console.error("Error fetching product:", productError);
    toast.error("Failed to load product details");
    // Fallback to static product
    setProduct(staticProduct);
  }
}, [productError]);

const handleColorSelect = (colorName) => {
  setSelectedColor(colorName);
};

// Image upload handler
const handleImageUpload = (e) => {
  const files = Array.from(e.target.files);
  
  if (reviewImages.length + files.length > 5) {
    setErrors(prev => ({
      ...prev,
      images: 'You can upload maximum 5 images'
    }));
    return;
  }

  const validFiles = files.filter(file => {
    if (!file.type.startsWith('image/')) {
      return false;
    }
    if (file.size > 5 * 1024 * 1024) {
      setErrors(prev => ({
        ...prev,
        images: 'Each image should be less than 5MB'
      }));
      return false;
    }
    return true;
  });

  setReviewImages(prev => [...prev, ...validFiles]);
  setErrors(prev => ({ ...prev, images: '' }));
};

const removeImage = (index) => {
  setReviewImages(prev => prev.filter((_, i) => i !== index));
};

// Form validation
const validateForm = () => {
  const newErrors = {};
  
  if (!reviewRating) newErrors.rating = 'Please select a rating';
  if (!reviewTitle.trim()) newErrors.title = 'Review title is required';
  if (!reviewDescription.trim()) newErrors.description = 'Review description is required';
  if (!reviewerName.trim()) newErrors.name = 'Your name is required';
  if (!reviewerEmail.trim()) {
    newErrors.email = 'Email is required';
  } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(reviewerEmail)) {
    newErrors.email = 'Please enter a valid email';
  }
  
  setErrors(newErrors);
  return Object.keys(newErrors).length === 0;
};

// Form submission handler
const handleSubmitReview = async () => {
  if (!validateForm()) return;

  setIsSubmitting(true);

  try {
    const formData = new FormData();
    formData.append('product_id', id);
    formData.append('rating', reviewRating);
    formData.append('title', reviewTitle);
    formData.append('comment', reviewDescription);
    formData.append('user_id', user.id);
    formData.append('product_type', 'normal');
    
    reviewImages.forEach((image, index) => {
      if (typeof image !== 'string') {
        formData.append(`images[${index}]`, image);
      }
    });

    reviewMutation.mutate(formData);
  } finally {
    setIsSubmitting(false);
  }
};

// Static data for fallback
const staticProduct = {
  id: 37,
  name: "8 mm Red Sandalwood Mala",
  description: "<p><strong>Red Sandalwood 8mm Mala</strong><br>Crafted from high-quality red sandalwood beads, this 8mm mala is a symbol of spiritual purity and tranquility. Known for its natural fragrance and calming properties, red sandalwood is traditionally used in meditation and prayer to promote focus and mental clarity.</p><p>Each bead is carefully selected and hand-strung to create a balanced and durable mala that can be worn as a necklace or wrapped around the wrist. Ideal for daily meditation, japa (chanting), or simply as a spiritually significant accessory.</p><ul><li class=\"list-item\"><p><strong>Material:</strong> Authentic red sandalwood</p></li><li class=\"list-item\"><p><strong>Bead Size:</strong> 8mm</p></li><li class=\"list-item\"><p><strong>Bead Count:</strong> 108 + 1 guru bead</p></li><li class=\"list-item\"><p><strong>Use:</strong> Meditation, chanting, or spiritual wear</p></li></ul><p></p><p>A perfect companion for those seeking inner peace, mindfulness, and a deeper spiritual connection.</p><p></p><p>The size of each bead may not be exactly the same as the beads are made manually. </p>",
  price: "1300.00",
  sale_price: "1050.00",
  stock: 18,
  material: "Red Sandalwood",
  size: "8 mm",
  media: [
    { file_path: Thumbnail1 },
    { file_path: Thumbnail2 },
    { file_path: Thumbnail3 },
    { file_path: Thumbnail4 }
  ],
  reviews: [],
  is_fav: false
};

const breadcrumbItems = [
  { label: "Home", url: "/" },
  { label: "Products", url: "/products/product" },
  { label: product?.name || "Loading..." },
];

const thumbnails = [Thumbnail1, Thumbnail2, Thumbnail3, Thumbnail4, Thumbnail5];
const mainImages = [Thumbnail1, Thumbnail2, Thumbnail3, Thumbnail4, Thumbnail5];

const sizeStockStatus = {
  "4 mm": true,
  "5 mm": false,
  "6 mm": true,
  "7 mm": true,
  "8 mm": false
};

const toggleWishlist = (productId) => {
  if (user) {
    wishlistMutation.mutate({
      productId: productId,
      productType: "normal",
    });
  } else {
    toast.info("Please login to add to wishlist");
  }
};

const toggleCart = (product) => {
  const existingProduct = cart.some((p) => p.id === product.id);
  if (!existingProduct) {
    dispatch(addToCartAction({ ...product, quantity: 1 }));
    toast.success("Added to cart");
  } else {
    dispatch(removeFromCart(product.id));
    toast.success("Removed from cart");
  }
};

const addToCart = (product) => {
  dispatch(addToCartAction({ ...product, quantity: quantity }));
  toast.success("Added to cart");
};

const buyNow = (product) => {
  dispatch(addToCartAction({ ...product, quantity: 1 }));
  navigate('/cart/cart')
};

const handleThumbClick = (index) => {
  setActiveIndex(index);
  if (mainSwiper) {
    mainSwiper.slideTo(index);
  }
};

const increaseQuantity = () => {
  setQuantity((prev) => prev + 1);
};

const decreaseQuantity = () => {
  if (quantity > 1) {
    setQuantity((prev) => prev - 1);
  }
};

const toggleFavorite = (product) => {
  if (user) {
    wishlistMutation.mutate({
      productId: product.id,
      productType: product.is_combo ? "combo" : "normal",
    });
  } else {
    toast.info("Please login to add to wishlist");
  }
};

const selectSize = (id, size) => {
  navigate(`/products/${id}`);
};

const renderStars = (rating) => {
  return [...Array(5)].map((_, i) => (
    <FaStar key={i} color={i < rating ? "#ffc107" : "#e4e5e9"} />
  ));
};

const handleShare = async () => {
  if (navigator.canShare && navigator.canShare({ files: [] })) {
    try {
      const response = await fetch(IMAGE_PATH + product.media[0].file_path); // image URL of your product
      const blob = await response.blob();
      const file = new File([blob], "product.jpg", { type: blob.type });

      await navigator.share({
        title: product.name,
        text: `Check out this product: ${product.name}`,
        files: [file],
        url: window.location.href, 
      });
    } catch (err) {
      console.error("Error sharing with image:", err);
      fallbackCopy();
    }
  } else if (navigator.share) {
    // fallback to normal share without image
    try {
      await navigator.share({
        title: product.name,
        text: `Check out this product: ${product.name}`,
        url: window.location.href,
      });
    } catch (err) {
      console.error("Error sharing:", err);
    }
  } else {
    fallbackCopy();
  }
};

const fallbackCopy = async () => {
  try {
    await navigator.clipboard.writeText(window.location.href);
    toast.success("Link copied to clipboard!");
  } catch (err) {
    toast.error("Failed to copy link");
  }
};


//get secondary image

const getSecondProductImage = (product) => {
  for (let x = 1 ; x <= product.media.length ; x++) {
    
    const imageTypes = ['image/jpeg','image/png','image/webp'];
    if (imageTypes.includes(product.media[x].file_type)) {
      return `${product.media[x].file_path}`;
    }
  }
};

const renderSkeletonImages = () => {
  return (
    <div className="ProductDetailsLeft">
      <div className="ProductDetailsThumbBox">
        <Swiper
          direction="vertical"
          spaceBetween={10}
          slidesPerView={4}
          className="thumb-swiper"
        >
          {[...Array(4)].map((_, index) => (
            <SwiperSlide key={index}>
              <div className="ThumbnailImgBox">
                <Skeleton height={80} width={80} />
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="ProductDetailsImgBox">
        <Skeleton height={500} />
      </div>
    </div>
  );
};

const renderSkeletonDetails = () => {
  return (
    <div className="ProductDetailsRight">
      <div className="ProductTilte">
        <Skeleton width={300} height={30} />
      </div>
      <div className="ProductReviewBox">
        <Skeleton width={150} height={20} />
      </div>
      <div className="ProductPriceBox">
        <Skeleton width={100} height={30} />
      </div>
      <div className="ProductSizeBox">
        <Skeleton width={200} height={20} />
        <div className="SizeBox">
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} width={50} height={30} style={{ marginRight: 10 }} />
          ))}
        </div>
      </div>

      <div className="ProductColorBox">
        <Skeleton width={200} height={20} />
      </div>

      <div className="ProductStockBox">
        <Skeleton width={150} height={20} />
      </div>
      <div className="ProductQtyCartFavSare">
        <Skeleton width={120} height={50} />
        <Skeleton width={150} height={50} style={{ marginLeft: 20 }} />
      </div>
      <div className="ProductBuyNow">
        Buy Now
      </div>
      <div className="ProductDelveryReturnBox">
        <Skeleton width={300} height={20} />
        <Skeleton width={300} height={20} style={{ marginTop: 10 }} />
      </div>
    </div>
  );
};

const renderSkeletonRecommended = () => {
  return (
    <div className="homProductCardList">
      {[...Array(4)].map((_, index) => (
        <div className="ProductBox" key={index}>
          <div className="ProductImage">
            <Skeleton height={250} />
          </div>
          <div className="ProductText">
            <Skeleton width={150} height={20} />
            <Skeleton width={100} height={20} style={{ marginTop: 10 }} />
          </div>
        </div>
      ))}
    </div>
  );
};

// Use the actual product data or fallback to static data
const currentProduct = product || staticProduct;
const isLoading = productLoading && !product;

return (
  <>
    <Helmet>
      {/* Dynamic Page Title */}
      <title>
        {currentProduct?.name
          ? `${currentProduct.name} | XKEI Wellness`
          : 'XKEI Wellness | Premium Supplements & Health Products'}
      </title>

      {/* Meta Description */}
      <meta
        name="description"
        content={
          currentProduct?.short_description
            ? currentProduct.short_description
            : currentProduct?.name
            ? `Shop ${currentProduct.name} — premium quality supplements for energy, immunity, and wellness at XKEI Wellness.`
            : 'Explore high-quality supplements, vitamins, and wellness products for a healthier lifestyle at XKEI Wellness.'
        }
        key="desc"
      />

      {/* Meta Keywords */}
      <meta
        name="keywords"
        content={
          currentProduct
            ? `${currentProduct.name}, ${currentProduct.category || 'supplements'}, ${currentProduct.brand || 'health brand'}, XKEI Wellness, vitamins, nutrition, wellness products`
            : 'XKEI Wellness, supplements, vitamins, nutrition, wellness store, health products, protein powder, immunity boosters'
        }
        key="keywords"
      />

      {/* Open Graph (Facebook, LinkedIn) */}
      <meta property="og:type" content="product" key="ogtype" />
      <meta property="og:title" content={currentProduct?.name || 'XKEI Wellness'} key="ogtitle" />
      <meta
        property="og:description"
        content={
          currentProduct?.name
            ? `Buy ${currentProduct.name} at XKEI Wellness. Trusted source for premium supplements and vitamins.`
            : 'Shop premium health supplements, vitamins, and nutrition essentials at XKEI Wellness.'
        }
        key="ogdesc"
      />
      <meta
        property="og:image"
        content={
          currentProduct?.media?.[0]?.file_path
            ? `${IMAGE_PATH}${currentProduct.media[0].file_path}`
            : `${IMAGE_PATH}default.jpg`
        }
        key="ogimage"
      />
      <meta
        property="og:url"
        content={
          currentProduct?.id
            ? `https://www.xkeiwellness.com/products/${currentProduct.id}`
            : 'https://www.xkeiwellness.com'
        }
        key="ogurl"
      />
      <meta property="og:site_name" content="XKEI Wellness" key="ogsitename" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" key="twcard" />
      <meta name="twitter:title" content={currentProduct?.name || 'XKEI Wellness'} key="twtitle" />
      <meta
        name="twitter:description"
        content={
          currentProduct?.name
            ? `Buy ${currentProduct.name} from XKEI Wellness. Premium supplements for strength, focus, and wellness.`
            : 'Shop premium supplements and health essentials at XKEI Wellness.'
        }
        key="twdesc"
      />
      <meta
        name="twitter:image"
        content={
          currentProduct?.media?.[0]?.file_path
            ? `${IMAGE_PATH}${currentProduct.media[0].file_path}`
            : `${IMAGE_PATH}default.jpg`
        }
        key="twimage"
      />
      <meta name="twitter:site" content="@XKEIWellness" key="twsite" />

      {/* Canonical URL */}
      <link
        rel="canonical"
        href={
          currentProduct?.id
            ? `https://www.xkeiwellness.com/products/${currentProduct.id}`
            : 'https://www.xkeiwellness.com'
        }
      />
    </Helmet>


    <div id="ProductDetails">
      <div className="BreadCrumbsBox">
        <div className="container">
          <Breadcrumbs items={breadcrumbItems} />
        </div>
      </div>
      <div className="container">
        <div className="ProductDetailsMain">
          <div className="ProductDetailsImgBuyBox">
            {isLoading ? (
              <>
                {renderSkeletonImages()}
                {renderSkeletonDetails()}
              </>
            ) : (
              <>
                <div className="ProductDetailsLeft">
                  <div className="ProductDetailsThumbBox">
                    <Swiper
                      onSwiper={setThumbsSwiper}
                      direction="vertical"
                      spaceBetween={10}
                      slidesPerView={4}
                      watchSlidesProgress
                      className="thumb-swiper"
                    >
                      {(currentProduct?.media?.length ? currentProduct.media : thumbnails).map((item, index) => (
                        <SwiperSlide key={index}>
                          <div
                            className={`ThumbnailImgBox ${activeIndex === index ? "active" : ""}`}
                            onClick={() => handleThumbClick(index)}
                          >
                            {item.file_type?.startsWith("image") ? (
                              <img
                                src={`${IMAGE_PATH}${item.file_path}`}
                                alt={`Thumbnail ${index + 1}`}
                              />
                            ) : item.file_type?.startsWith("video") ? (
                              <video
                                src={`${IMAGE_PATH}${item.file_path}`}
                                style={{ width: "100%", height: "auto" }}
                              />
                            ) : item.file_type === "iframe" ? (
                              <div
                                className="iframe-thumb"
                                dangerouslySetInnerHTML={{ __html: item.file_path }}
                              />
                            ) : (
                              <span>Unsupported media</span>
                            )}
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>

                  <div className="ProductDetailsImgBox">
                    <PhotoProvider>
                      <Swiper
                        modules={[Navigation, Thumbs]}
                        thumbs={{ swiper: thumbsSwiper }}
                        onSwiper={setMainSwiper}
                        onSlideChange={(swiper) => setActiveIndex(swiper.activeIndex)}
                        className="main-swiper"
                      >
                        {(currentProduct?.media?.length ? currentProduct.media : mainImages).map((item, index) => (
                          <SwiperSlide key={index}>
                            {item.file_type?.startsWith("image") ? (
                              <PhotoView src={`${IMAGE_PATH}${item.file_path}`}>
                                <img
                                  src={`${IMAGE_PATH}${item.file_path}`}
                                  alt={`Product ${index + 1}`}
                                  className="main-image"
                                />
                              </PhotoView>
                            ) : item.file_type?.startsWith("video") ? (
                              <video
                                src={`${IMAGE_PATH}${item.file_path}`}
                                autoPlay
                                controls
                                className="main-image"
                              />
                            ) : item.file_type === "iframe" ? (
                              <div
                                className="iframe-wrapper"
                                dangerouslySetInnerHTML={{ __html: item.file_path }}
                              />
                            ) : (
                              <span>Unsupported media</span>
                            )}
                          </SwiperSlide>
                        ))}
                      </Swiper>
                    </PhotoProvider>
                  </div>
                </div>

                <div className="ProductDetailsRight">
                  <div className="ProductTilte">
                    <h2>{currentProduct?.name || "Rudraksha Mala"}</h2>
                  </div>
                  {currentProduct?.reviews?.length ? (
                    <div className="ProductReviewBox">
                      <div className="ReviewBox">
                        <div className="Rating">
                          <p>
                            {(
                              currentProduct.reviews.reduce((sum, review) => sum + parseInt(review.rating), 0) / 
                              currentProduct.reviews.length
                            ).toFixed(1)}
                          </p>
                        </div>
                        {renderStars(
                          Math.round(
                            currentProduct.reviews.reduce((sum, review) => sum + parseInt(review.rating), 0) / 
                            currentProduct.reviews.length
                          )
                        )}
                      </div>
                      <div className="ReviewCount">
                        <p>({currentProduct.reviews.length} review{currentProduct.reviews.length !== 1 ? 's' : ''})</p>
                      </div>
                    </div>
                  ) : (
                    <div className="ProductReviewBox">
                      <div className="ReviewCount">
                        
                      </div>
                    </div>
                  )}

                  <div className="ProductPriceBox">
                    <div className="ProductCurrentPrice">
                      <p>₹{currentProduct?.sale_price || "1500"}</p>
                    </div>
                    {currentProduct?.price !== currentProduct?.sale_price && (
                      <>
                        <div className="ProductOrginalPrice">
                          <p>₹{currentProduct?.price || "3000"}</p>
                        </div>
                        <div className="PriceSaveUpto">
                          <p>-{currentProduct ? Math.round((1 - currentProduct.sale_price / currentProduct.price) * 100) : 29}%</p>
                        </div>
                      </>
                    )}
                  </div>

                  <div className="ProductSizeBox">
                    <div className="SizeTitle">
                      <p>Size :</p>
                      <p>{currentProduct.size}</p>
                    </div>
                    <div className="SizeBox">
                      {productSizes.map((size) => (
                        <div
                          key={size.id}
                          className={`Size ${currentProduct.size === size.size ? "selected" : ""}`}
                          onClick={() => selectSize(size.id, size.size)}
                        >
                          <p className="SizeShow">{size.size}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="ProductColorBox">
                  
                    <div className="SelectColorBox">
                      {currentProduct.varient && (
                        <div className="selectcolorTitle">
                          <p>Selected Flavour : </p>
                          <p>{currentProduct.varient}</p>
                        </div>
                      )}
                      
                      <div className="SelectColorImgBox">
                        {colorVariants.map((color) =>
                          
                            <div
                              key={color.id}
                              className={`SelectColorImg ${currentProduct.varient === color.varient ? "active" : ""}`}
                              onClick={() => navigate(`/products/${color.id}`)}
                            >
                              {color.varient}
                            </div>
                          
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="ProductStockBox">
                    <div className="ProductStock">
                      <p>Stock:</p>
                    </div>
                    <div className="ProductStcokShow">
                      {currentProduct?.stock ? (
                        currentProduct.stock > 0 ? (
                          <p className="InStock">In Stock ({currentProduct.stock} available)</p>
                        ) : (
                          <p className="OutOfStock">Out of Stock</p>
                        )
                      ) : sizeStockStatus[selectedSize] ? (
                        <p className="InStock">In Stock</p>
                      ) : (
                        <p className="OutOfStock">Out of Stock</p>
                      )}
                    </div>
                  </div>

                  <div className="ProductQtyCartFavSare">
                    <div className="ProductQtyBox">
                      <div className="QtyMinus" onClick={decreaseQuantity}>
                        <p>-</p>
                      </div>
                      <div className="QtyCount">
                        <p>{quantity}</p>
                      </div>
                      <div className="QtyPlus" onClick={increaseQuantity}>
                        <p>+</p>
                      </div>
                    </div>

                    <div className="ProductCart" onClick={() => { addToCart(currentProduct) }}>
                      <p>ADD TO CART</p>
                      <RiShoppingCartLine className="cart-icon" />
                    </div>

                    <div className="FavSareBox">
                      <div className="FavIconBoxContainer">
                        <div className="FavIconBox" onClick={() => { toggleFavorite(currentProduct) }}>
                          {isFavorite ? (
                            <MdFavorite
                              className="fav-icon"
                              style={{ color: "red" }}
                            />
                          ) : (
                            <MdFavoriteBorder className="fav-icon" />
                          )}
                          <span className="tooltip">
                            {isFavorite
                              ? "Remove from favorites"
                              : "Add to favorites"}
                          </span>
                        </div>
                      </div>

                      <div className="ShareIconBoxContainer">
                        <div className="ShareIconBox">
                          <MdOutlineShare className="share-icon" onClick={handleShare} />
                          <span className="tooltip">Share this product</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="ProductBuyNow" onClick={() => buyNow(currentProduct)}>
                    
                      <p>BUY IT NOW</p>
                    
                  </div>

                  <div className="ProductDelveryReturnBox">
                    <div className="EstimateDelivery">
                      <PiClockCountdown className="delivery-icon" />
                      <p className="DeliveryTime">
                        Estimate delivery times:{" "}
                        <span className="Days">6-7 days</span> 
                      </p>
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          
          <div className="SpecificationsBox">
            <div className="SpecificationsHead">
              <h2>Specifications</h2>
            </div>
            <div className="ProductDetailsBox">
              <div className="ProductSortDesc" dangerouslySetInnerHTML={{ __html: product?.description || staticProduct.description }} />
              <div className="DetailsBox">
                {/* Sales Package */}
                <div className="Box">
                  <div className="BoxTitle">
                    <p>Sales Package</p>
                  </div>
                  <div className="BoxDetails">
                    <div className="SubDetails">
                      <p>Pack of</p>
                      <p>{product?.pack_of || '1'}</p>
                    </div>
                    <div className="SubDetails">
                      <p>Net Quantity</p>
                      <p>{product?.net_quantity || product?.quantity}</p>
                    </div>
                    <div className="SubDetails">
                      <p>Flavor</p>
                      <p>{product?.flavor || selectedColor}</p>
                    </div>
                    <div className="SubDetails">
                      <p>Form</p>
                      <p>{product?.form || '-'}</p>
                    </div>
                    <div className="SubDetails">
                      <p>Shelf Life</p>
                      <p>{product?.shelf_life || '-'}</p>
                    </div>
                    <div className="SubDetails">
                      <p>Dietary Preference</p>
                      <p>{product?.dietary_preference || '-'}</p>
                    </div>
                  </div>
                </div>

                {/* Product Details */}
                <div className="Box">
                  <div className="BoxTitle">
                    <p>Product Details</p>
                  </div>
                  <div className="BoxDetails">
                    <div className="SubDetails">
                      <p>Brand</p>
                      <p>{product?.brand || '-'}</p>
                    </div>
                    <div className="SubDetails">
                      <p>Product Name</p>
                      <p>{product?.product_name || product?.name}</p>
                    </div>
                    <div className="SubDetails">
                      <p>Model Number</p>
                      <p>{product?.model_number || '-'}</p>
                    </div>
                    <div className="SubDetails">
                      <p>Type</p>
                      <p>{product?.type || '-'}</p>
                    </div>
          
                    <div className="SubDetails">
                      <p>Usage Occasion</p>
                      <p>{product?.usage_occasion || '-'}</p>
                    </div>
                    <div className="SubDetails">
                      <p>Number of Servings</p>
                      <p>{product?.number_of_servings || '-'}</p>
                    </div>
                  </div>
                </div>

                {/* Nutrition & Composition */}
                <div className="Box">
                  <div className="BoxTitle">
                    <p>Nutrition & Composition</p>
                  </div>
                  <div className="BoxDetails">
                    <div className="SubDetails">
                      <p>Protein per Serving</p>
                      <p>{product?.protein_per_serving || '-'}</p>
                    </div>
                    {/* <div className="SubDetails">
                      <p>Carbohydrates per Serving</p>
                      <p>{product?.carbs_per_serving || '2 g'}</p>
                    </div> */}
                    <div className="SubDetails">
                      <p>Fat per Serving</p>
                      <p>{product?.fat_per_serving || '-'}</p>
                    </div>
                    <div className="SubDetails">
                      <p>BCAAs per Serving</p>
                      <p>{product?.bcaas_per_serving || '-'}</p>
                    </div>
                    <div className="SubDetails">
                      <p>EAAs per Serving</p>
                      <p>{product?.eaas_per_serving || '-'}</p>
                    </div>
                    <div className="SubDetails">
                      <p>Added Sugar</p>
                      <p>{product?.added_sugar || '-'}</p>
                    </div>
                    <div className="SubDetails">
                      <p>Serving Size</p>
                      <p>{product?.serving_size || '-'}</p>
                    </div>
                    
                  </div>
                </div>

              </div>

            </div>
          </div>
          {product?.product_description?.length > 0 && (
              <div className="ProductManuFacturerBox">
                <div className="ProductManuFacturerHead">
                  <h2>Product Description</h2>
                </div>
                <div className="ManufacturerBox">
                  {product?.product_description?.map((section, index) => {
                    // Determine layout based on index (alternating pattern)
                    const isEvenIndex = index % 2 === 0;
                    
                    return (
                      <div className="Box" key={section.id || index}>
                        <div className="BoxImgDesc">
                          {/* Image on left for even indexes, right for odd indexes */}
                          {isEvenIndex && (
                            <div className="BoxImg">
                              <img 
                                src={section.image_path ? `${IMAGE_PATH}${section.image_path}` : Manufatur1} 
                                alt={`Product description ${index + 1}`}
                                onError={(e) => {
                                  e.target.src = Manufatur1; // Fallback image
                                }}
                              />
                            </div>
                          )}
                          
                          <div className="boxTitleDesc">
                            <div className="BoxDesc">
                              {/* Display full content with HTML */}
                              {section.content ? (
                                <div dangerouslySetInnerHTML={{ __html: section.content }} />
                              ) : (
                                <p>No description available.</p>
                              )}
                            </div>
                          </div>

                          {!isEvenIndex && (
                            <div className="BoxImg">
                              <img 
                                src={section.image_path ? `${IMAGE_PATH}${section.image_path}` : Manufatur2} 
                                alt={`Product description ${index + 1}`}
                                onError={(e) => {
                                  e.target.src = Manufatur2; // Fallback image
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
          )}


          <div className="ProductReviewSowBox">
            
            <div className="ProductReviewSowBoxHead">
              <h2>Ratings & Reviews</h2>
            </div>
            
            {/* Calculate average rating from reviews */}
            {product?.reviews?.length > 0 && (
              <div className="ReviewRateShowBox">
                <div className="ReviewRateSow">
                  <div className="TotalRate">
                    <p>
                      {(
                        product.reviews.reduce((acc, review) => acc + parseInt(review.rating), 0) / 
                        product.reviews.length
                      ).toFixed(1)}
                    </p>
                    <p>/5</p>
                  </div>
                  <div className="RateStar">
                    {renderStars(
                      Math.round(
                        product.reviews.reduce((acc, review) => acc + parseInt(review.rating), 0) / 
                        product.reviews.length
                      )
                    )}
                  </div>
                  <div className="RateCount">
                    <p>Based on {product.reviews.length} review{product.reviews.length !== 1 ? 's' : ''}</p>
                  </div>
                </div>
                
                {/* Rating distribution bar */}
                <div className="ReviewRateBarBox">
                  {[5, 4, 3, 2, 1].map((rating) => {
                    const count = product.reviews.filter(r => parseInt(r.rating) === rating).length;
                    const percentage = (count / product.reviews.length) * 100;
                    
                    return (
                      <div className="ReviewRateBar" key={rating}>
                        <div className="RateBarNumber">
                          <p>{rating}</p>
                        </div>
                        <div className="RateBarStar">
                          <FaStar />
                        </div>
                        <div className="RateBar">
                          <div 
                            className="RateBarFill" 
                            style={{ width: `${percentage}%` }}
                          />
                        </div>
                        <div className="RateUserCount">
                          <p>{count}</p>
                        </div>
                      </div>
                    );
                  })}
                </div>
                
                <div className="ReviewRateWrite">
                  <div 
                    className="WriteReviewBox" 
                    onClick={() => setShowReviewForm(!showReviewForm)}
                  >
                    <p>Write a review</p>
                    <FaPencilAlt className="PencilIcon" />
                  </div>
                </div>
              </div>
            )}
            
            {/* Display review images gallery */}
            {product?.review_images?.length > 0 && (
              <div className="ReviewGalleryBox">
                <div className="GalleryBox">
                  {product.review_images.slice(0, 9).map((image, index) => (
                    <div className="Box" key={index}>
                      <img 
                        src={`${IMAGE_PATH}${image.image_path}`} 
                        alt={`Review ${index + 1}`} 
                      />
                    </div>
                  ))}
                  {product.review_images.length > 9 && (
                    <a href="/gallery/gallery" className="Box LastBox">
                      <img 
                        src={`${IMAGE_PATH}${product.review_images[0].image_path}`} 
                        alt="More reviews" 
                      />
                      <div className="CountTotalImg">
                        <FiPlus className="PlusIcon" />
                        <p>{product.review_images.length - 9}</p>
                      </div>
                    </a>
                  )}
                </div>
              </div>
            )}
            
            
            

            <div className="ReviewCommentBox">
              {showReviewForm && (
                <div className="ReviewFormContainer">
                  <div className="ReviewFormHeader">
                    <h3>Write a Review</h3>
                    <p>Share your thoughts about this product</p>
                  </div>

                  <form onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmitReview();
                  }}>
                    <div className="ReviewRatingInput">
                      <p>Your Rating: <span className="required">*</span></p>
                      <div className="StarRating">
                        {[1, 2, 3, 4, 5].map((star) => (
                          <FaStar 
                            key={star}
                            className="star-icon"
                            color={star <= reviewRating ? "#ffc107" : "#e4e5e9"}
                            onClick={() => setReviewRating(star)}
                            size={24}
                          />
                        ))}
                      </div>
                      {errors.rating && <p className="error-message">{errors.rating}</p>}
                    </div>
                    
                    <div className="ReviewFormInput">
                      <label>Review Title <span className="required">*</span></label>
                      <input
                        type="text"
                        value={reviewTitle}
                        onChange={(e) => setReviewTitle(e.target.value)}
                        placeholder="Summarize your review"
                        className={errors.title ? 'error' : ''}
                      />
                      {errors.title && <p className="error-message">{errors.title}</p>}
                    </div>
                    
                    <div className="ReviewFormInput">
                      <label>Review Description <span className="required">*</span></label>
                      <textarea
                        value={reviewDescription}
                        onChange={(e) => setReviewDescription(e.target.value)}
                        placeholder="Share details about your experience with this product"
                        rows={5}
                        className={errors.description ? 'error' : ''}
                      />
                      {errors.description && <p className="error-message">{errors.description}</p>}
                    </div>

                    <div className="ReviewFormInput">
                      <label>Upload Images (Max 5)</label>
                      <div className="image-upload-container">
                        <label className="image-upload-button">
                          <input
                            type="file"
                            multiple
                            accept="image/*"
                            onChange={handleImageUpload}
                            style={{ display: 'none' }}
                          />
                          <FiPlus className="upload-icon" />
                          <span>Add Photos</span>
                        </label>
                        <div className="uploaded-images-preview">
                          {reviewImages.map((image, index) => (
                            <div key={index} className="image-preview-item">
                              <img 
                                src={typeof image === 'string' ? image : URL.createObjectURL(image)} 
                                alt={`Preview ${index}`} 
                              />
                              <button 
                                type="button"
                                className="remove-image-btn"
                                onClick={() => removeImage(index)}
                              >
                                &times;
                              </button>
                            </div>
                          ))}
                        </div>
                      </div>
                      {errors.images && <p className="error-message">{errors.images}</p>}
                    </div>
                    
                    <div className="ReviewFormInput">
                      <label>Your Name <span className="required">*</span></label>
                      <input
                        type="text"
                        value={reviewerName}
                        onChange={(e) => setReviewerName(e.target.value)}
                        placeholder="Enter your name"
                        className={errors.name ? 'error' : ''}
                      />
                      {errors.name && <p className="error-message">{errors.name}</p>}
                    </div>
                    
                    <div className="ReviewFormInput">
                      <label>Your Email <span className="required">*</span></label>
                      <input
                        type="email"
                        value={reviewerEmail}
                        onChange={(e) => setReviewerEmail(e.target.value)}
                        placeholder="Enter your email"
                        className={errors.email ? 'error' : ''}
                      />
                      {errors.email && <p className="error-message">{errors.email}</p>}
                    </div>
                    
                    <div className="ReviewFormActions">
                      <button 
                        type="submit"
                        className="SubmitReviewBtn"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? 'Submitting...' : 'Submit Review'}
                      </button>
                      <button 
                        type="button"
                        className="CancelReviewBtn"
                        onClick={() => setShowReviewForm(false)}
                        disabled={isSubmitting}
                      >
                        Cancel
                      </button>
                    </div>
                  </form>
                </div>
              )}
              
              <div className="CommentBox">
                {product?.reviews?.length > 0 ? (
                  product.reviews.map((review) => (
                    <div className="ReviewCmtUserBox" key={review.id}>
                      <div className="ReviewHeader">
                        <div className="UserNameImgBox">
                          <div className="ImgBox">
                            <img 
                              src={review.user?.photo ? `${IMAGE_PATH}${review.user.photo}` : Customer1} 
                              alt={review.user?.name || 'Customer'} 
                            />
                          </div>
                          <div className="NameProductSizeBox">
                            <div className="UserName">
                              <p>{review.user?.name || 'Customer'}</p>
                            </div>
                            <div className="VerifyIconText">
                              <LuBadgeCheck />
                              <p>Verified Purchase</p>
                            </div>
                          </div>
                        </div>
                        <div className="ReviewRatingShow">
                          {renderStars(parseInt(review.rating))}
                        </div>
                      </div>
                      <div className="ReviewComment">
                        <div className="CmtTitle">
                          <p>{review.title}</p>
                        </div>
                        <div className="CmtDesc">
                          <p>{review.details}</p>
                        </div>
                        <div className="ReviewWriteTimeDate">
                          <p>{new Date(review.created_at).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric'
                          })}</p>
                        </div>
                      </div>
                      
                      {/* Display review images if any */}
                      {review.image?.length > 0 && (
                        <div className="CustomerProductPhoto">
                          {review.image.map((img, imgIndex) => (
                            <div className="PhotoBox" key={imgIndex}>
                              <img 
                                src={`${IMAGE_PATH}${img.image_path}`} 
                                alt={`Review ${imgIndex + 1}`} 
                              />
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  ))
                ) : (
                  <div className="ReviewRateShowBox">
                    <p>Be the first to review this product!</p>
                    <div className="ReviewRateWrite">
                      <div 
                        className="WriteReviewBox" 
                        onClick={() => setShowReviewForm(!showReviewForm)}
                      >
                        <p>Write a review</p>
                        <FaPencilAlt className="PencilIcon" />
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="MostRelatedBox">
            <div className="MostRelatedBoxHead">
              <h2>Related Products</h2>
            </div>
            {recommendedLoading ? (
              renderSkeletonRecommended()
            ) : (
              <div className="homProductCardList">
                {recommendedProducts.map((product) => (
                  <div
                    className="ProductBox"
                    key={product.id}
                    onMouseEnter={() => setHoveredProduct(product.id)}
                    onMouseLeave={() => {
                      setHoveredProduct(null);
                      setImageHovered(null);
                    }}
                  >
                    <Link to={`/products/${product.id}`} className="productLink">   
                      <div
                        className="ProductImage"
                        onMouseEnter={() => setImageHovered(product.id)}
                        onMouseLeave={() => {
                          if (hoveredProduct !== product.id) {
                            setImageHovered(null);
                          }
                        }}
                      >
                        {product.media ? (
                          <>
                            <img
                              src={`${IMAGE_PATH}${product.media[0]?.file_path}`}
                              className={
                                imageHovered === product.id ? "fade-out" : "fade-in"
                              }
                              alt={product.name}
                            />
                            {product.media[1] && (
                              <img
                                src={`${IMAGE_PATH}${getSecondProductImage(product)}`}
                                className={
                                  imageHovered === product.id ? "fade-in" : "fade-out"
                                }
                                alt={product.name}
                              />
                            )}
                          </>
                        ) : (
                          <>
                            <img
                              src={product.image1}
                              className={
                                imageHovered === product.id ? "fade-out" : "fade-in"
                              }
                              alt={product.title}
                            />
                            <img
                              src={product.image2}
                              className={
                                imageHovered === product.id ? "fade-in" : "fade-out"
                              }
                              alt={product.title}
                            />
                          </>
                        )}
                      </div>

                      <div className="ProductText">
                        <h3>{product.name || product.title}</h3>
                        <div className="priceContainer">
                          {product.sale_price && product.sale_price !== product.price ? (
                            <>
                              <p className="originalPrice">₹{product.price}</p>
                              <span className="offerPrice">₹{product.sale_price}</span>
                            </>
                          ) : product.offerPrice ? (
                            <>
                              <p className="originalPrice">{product.originalPrice}</p>
                              <span className="offerPrice">{product.offerPrice}</span>
                            </>
                          ) : (
                            <p className="offerPrice">₹{product.price || product.offerPrice}</p>
                          )}
                        </div>
                      </div>
                    </Link>

                    <div
                      className={`productIcons ${
                        hoveredProduct === product.id ? "visible" : ""
                      }`}
                      onMouseEnter={(e) => {
                        e.stopPropagation();
                        setHoveredProduct(product.id);
                      }}
                    >
                      <div
                        className="iconBox"
                        data-tooltip={
                          product.is_fav
                            ? "Remove from wishlist"
                            : "Add to wishlist"
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          toggleWishlist(product.id);
                        }}
                      >
                        {product.is_fav ? (
                          <FaHeart className="icon" style={{ color: "red" }} />
                        ) : (
                          <FiHeart className="icon" />
                        )}
                      </div>

                      <div
                        className="iconBox"
                        data-tooltip={cart.some(item => item.id === product.id) 
                          ? "Remove from cart" 
                          : "Add to cart"
                        }
                        onClick={(e) => {
                          e.preventDefault();
                          toggleCart(product);
                        }}
                      >
                        {cart.some(item => item.id === product.id) ? (
                          <FiTrash2 className="icon" />
                        ) : (
                          <FiShoppingCart className="icon" />
                        )}
                      </div>

                      <div className="iconBox" data-tooltip="Quick View">
                        <FiEye className="icon" />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    </>
    
  );
};

export default ProductDetails;